export const CookiesConstants = {
  consent: "CONSENT",
  consent_value_1: "Yep",
  consent_value_0: "Nope",
  consent_expiration: 730
};
